import samlAuth from './samlAuth';
import basicAuth from './basicAuth';
import logout from './logout'
import { paths } from '../config/app-config';

class Auth {
  async loginWithSaml() {
    return await samlAuth(paths);
  }

  async basicLogin({username, password}) {
    return await basicAuth({username, password, loginPath: paths.loginPath});
  }

  async logoutSaml() {
    return await logout('samlLogout');
  }

  async logout() {
    return await logout();
  }
}

export default new Auth();
